import { render } from "./index.vue?vue&type=template&id=2219858c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2219858c&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=2219858c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2219858c"]])

export default __exports__